import React from 'react'
import CategoriesTree from './CategoriesTree'

const Categories = () => {

    return (
      <div className="categories">
        <CategoriesTree/>
      </div>
    );
}

export default Categories
